import { gql } from "@apollo/client";

export const APPLY_EXCEPTION = gql`
  mutation ApplyException($input: ExceptionMutationInput!) {
    applyException(input: $input)
  }
`;
